import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showLanguageSelector: true,
  showLiveChat: true,
  showEmptyWinterTyreSelect: true,
}

export default config
